import SuiteProductLevelIdentifiersMap from 'pricing-pages-ui/constants/merchCards/SuiteProductLevelIdentifiersMap';
import { useCurrencyCodeUnitToDisplay, useDisplayedCurrencyCode } from '../../../hooks/useCurrencies';
import SkeletonLoadWrapper from '../../common/loading/SkeletonLoadWrapper';
import { PriceDisplayStyled } from './PriceDisplayStyled';
import { useCrmSuitePricingInfo } from './useCrmSuitePricingInfo';
import { jsx as _jsx } from "react/jsx-runtime";
export const CrmSuitePriceMerchCard = ({
  productLevel,
  showPricePerMonthPerSeat
}) => {
  const currencyCode = useDisplayedCurrencyCode();
  const currencyCodeUnit = useCurrencyCodeUnitToDisplay();
  const {
    pricingInfo,
    loading
  } = useCrmSuitePricingInfo({
    productLevel
  });
  return /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
    isLoading: loading,
    heights: [20, 33],
    widths: [60, 80],
    children: pricingInfo && /*#__PURE__*/_jsx(PriceDisplayStyled, {
      pricingInfo: pricingInfo,
      seleniumId: SuiteProductLevelIdentifiersMap[productLevel],
      showPricePerMonthPerSeat: showPricePerMonthPerSeat,
      currencyCode: currencyCode,
      currencyCodeUnit: currencyCodeUnit
    })
  });
};
export default CrmSuitePriceMerchCard;